import request from '@/plugins/request';

/**
 * 获取品牌视频列表（不分页）
 * @returns {Promise} - 返回Promise对象
 */
export function getVideoList() {
  return request({
    url: '/fronted/video/getList',
    method: 'get'
  });
}

/**
 * 获取品牌视频详情
 * @param {string|number} id - 视频ID
 * @returns {Promise} - 返回Promise对象
 */
export function getVideoDetail(id) {
  return request({
    url: `/fronted/video/${id}`,
    method: 'get'
  });
}
